export default __webpack_public_path__ + "c3e5269d294f1eb82b51a9ec8c4e4c1f.png";